 /* --- FLIXMEDIA --- */
 var container = "<section class=\"page-product-box-flix\" style=\"display:none\"><div id=\"flix-minisite\"></div><div id=\"flix-inpage\"></div></section>";

 $("#flixmedia-section").prepend(container);
 var product_mpn = window.product.variants[window.product.variants.length - 1].sku,
   product_ean = window.product.variants[window.product.variants.length - 1].barcode,
   product_brand = window.product.vendor,
   distributor = "16260",
   language = "es";

 var headID = document.getElementsByTagName("body")[0];
 var flixScript = document.createElement('script');
 flixScript.type = 'text/javascript';
 flixScript.async = true;
 flixScript.setAttribute('data-flix-distributor', distributor);
 flixScript.setAttribute('data-flix-language', language);
 flixScript.setAttribute('data-flix-brand', product_brand);
 flixScript.setAttribute('data-flix-ean', product_ean);
 flixScript.setAttribute('data-flix-mpn', product_mpn);
 flixScript.setAttribute('data-flix-inpage', 'flix-inpage');
 //flixScript.setAttribute('data-flix-button', 'flix-minisite');
 flixScript.setAttribute('data-flix-price', '');
 headID.appendChild(flixScript);

 flixScript.onload = function () {
   if (typeof (flixJsCallbacks) === "object") {
     flixJsCallbacks.setLoadCallback(function () {
       try {
          if ($(".loadbeeTabContent iframe").is(':visible')) return;

          // show flixmedia content in case it didn't load the first time
          $(".page-product-box-flix").show();
          $("#flixmedia-content").show();
          $("#loadbee-section").hide();
          $("#cnet-content").hide();
          document.getElementById("collapseFour").classList.remove("loading");
          document.querySelector('#page-characs-box').classList.remove("hidden");
          document.querySelector('.js-product-description-nav-item[data-tab-id="page-characs-box"]').classList.remove("hidden");
          document.querySelector('.js-sticky-product-description-nav-item[data-tab-id="page-characs-box"]').classList.remove("hidden");
       } catch (e) {}
     }, 'inpage');
   }
 };
 flixScript.src = '//media.flixfacts.com/js/loader.js';
 /* --- end FLIXMEDIA --- */